define([
    'slick'
], function (
) {
    var $gallerySlider = $('.image-gallery');

    $gallerySlider.each(function (index, item) {
        var $gallerySliderPreview = $(this).find('.content-gallery__preview').find('.slider__cycle');
        var $gallerySliderNav = $(this).find('.content-gallery__nav').find('.slider__cycle');

        $gallerySliderPreview.attr('id', 'preview_' + index);
        $gallerySliderNav.attr('id', 'nav_' + index);
        $gallerySliderPreview.find('a[data-type="image"]').attr('data-fancybox', 'image-gallery_' + index);

        $gallerySliderPreview.slick({
            arrows: false,
            dots: false,
            fade: true,
            focusOnSelect: false,
            infinite: false,
        });

        $gallerySliderNav.slick({
            asNavFor: '#preview_' + index,
            draggable: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            infinite: false,
            focusOnSelect: true,
            variableWidth: true,
            appendArrows: $(this).find('.content-gallery__nav .content-gallery__arrows'),
            prevArrow: '<span class="content-gallery__arrow content-gallery__arrow--prev" title="Previous"></span>',
            nextArrow: '<span class="content-gallery__arrow content-gallery__arrow--next" title="Next"></span>',
        });
    });
});
